<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [filtros]="filtros"
  [emptyState]="{
    title: 'Sin personal de salud',
    subtitle:
      'Todavía no hay médicos ni enfermeros cargados o ninguno coincide con los filtros.',
  }"
></app-tabla>
